wbApp.controller('LeadsTabsDetailCtrl', ['$scope', '$modal', '$translate', 'userSvc', 'notRegisteredUserSvc',
function ($scope, $modal, $translate, userSvc, notRegisteredUserSvc) {

    $scope.selectedLead = null;
    $scope.userEmailAddress = ''

    $scope.$on('leadSelectionChanged', function (e, newlySelectedLead) {
        $scope.selectedLead = newlySelectedLead;
    });

}]);
